module.exports = __webpack_public_path__ + "static/people_img17-829f5ebfb5c69d7bfcf91d7f30a9fa84.png";